import dateHelper from "flow/utils/dateHelper";

function validatePersonId(personId: string): boolean {
    if (personId === "") {
        return false;
    }

    const pid = stripTransform(personId);

    if (pid.length !== 12) {
        return false;
    }

    for (let i = 0; i < 8; i++) {
        if (isNaN(parseInt(pid[i]))) {
            return false;
        }
    }

    if (isValidPersonIdDate(pid.substr(0, 4), pid.substr(4, 2), pid.substr(6, 2)) === false) {
        return false;
    }

    const pidSubstring = pid.substr(8, 4);
    if (pidSubstring[0].toUpperCase() === "T" && pidSubstring[1].toUpperCase() === "F") {
        return !isNaN(parseInt(pidSubstring[2])) && !isNaN(parseInt(pidSubstring[3]));
    }

    if (pidSubstring[0].toUpperCase() === "T") {
        return (
            !isNaN(parseInt(pidSubstring[1])) && !isNaN(parseInt(pidSubstring[2])) && !isNaN(parseInt(pidSubstring[3]))
        );
    }

    // TODO: Verify
    if (
        isNaN(parseInt(pidSubstring[0])) ||
        isNaN(parseInt(pidSubstring[1])) ||
        isNaN(parseInt(pidSubstring[2])) ||
        isNaN(parseInt(pidSubstring[3]))
    ) {
        return false;
    }

    return verifyCheckDigit(pid);
}

function validatePersonIdAllowZeros(personId: string): boolean {
    if (personId === "") {
        return false;
    }

    const pid = stripTransform(personId);

    if (pid.length !== 12) {
        return false;
    }

    for (let i = 0; i < 8; i++) {
        if (isNaN(parseInt(pid[i]))) {
            return false;
        }
    }

    if (isValidPersonIdDate(pid.substr(0, 4), pid.substr(4, 2), pid.substr(6, 2)) === false) {
        return false;
    }

    const pidSubstring = pid.substr(8, 4);
    if (pidSubstring[0].toUpperCase() === "T" && pidSubstring[1].toUpperCase() === "F") {
        return !isNaN(parseInt(pidSubstring[2])) && !isNaN(parseInt(pidSubstring[3]));
    }

    if (pidSubstring[0].toUpperCase() === "T") {
        return (
            !isNaN(parseInt(pidSubstring[1])) && !isNaN(parseInt(pidSubstring[2])) && !isNaN(parseInt(pidSubstring[3]))
        );
    }

    if (
        isNaN(parseInt(pidSubstring[0])) ||
        isNaN(parseInt(pidSubstring[1])) ||
        isNaN(parseInt(pidSubstring[2])) ||
        isNaN(parseInt(pidSubstring[3]))
    ) {
        return false;
    }

    return verifyCheckDigit(pid) || pidSubstring === "0000";
}

function stripTransform(personId: string): string {
    if (personId === undefined || personId === null || personId === "") {
        return "Illegal format";
    }
    const now = new Date();
    let transformedPid = personId?.trim() || "";

    transformedPid = transformedPid.replace("-", "");
    transformedPid = transformedPid.replace("+", "");

    // Verify if already stripped: yyyymmddxxxx
    if (transformedPid.length === 12) {
        return transformedPid;
    }

    if (transformedPid.length !== 10) {
        return "Illegal format";
    }

    const year = transformedPid.substring(0, 2);

    /*** TODO: not sure what it does here, need help from someone to convert this ****/
    if (personId.indexOf("+") !== -1) {
        if (parseInt(year) > 50) {
            now.setFullYear(now.getFullYear() - 200);
        } else {
            now.setFullYear(now.getFullYear() - 100);
        }
    } else {
        if (parseInt(year) > parseInt(now.getFullYear().toString().substr(2, 2))) {
            now.setFullYear(now.getFullYear() - 100);
        }
    }

    //var modifiedDate = new Date(now);
    const century = now.getFullYear().toString().substr(0, 2);
    transformedPid = century + transformedPid;

    return transformedPid;
}

function doTransform(personId: string): string {
    if (personId === undefined || personId === null || personId === "") {
        return "";
    }
    // Transform only if length is 12, in other word including century
    if (personId.length === 12) {
        let newPid = "";
        newPid = newPid.concat(personId.substring(2, 8));

        const year = parseInt(personId.substring(0, 4));
        const month = parseInt(personId.substring(4, 6));
        const day = parseInt(personId.substring(6, 8));

        try {
            const birthDate = new Date(year, month, day);

            birthDate.setFullYear(year + 100, month, day);
            const today = new Date();
            // Is the person 100+ years old?
            if (today >= birthDate) {
                newPid = newPid.concat("+");
            } else {
                newPid = newPid.concat("-");
            }

            // last 4 digits
            newPid = newPid.concat(personId.substring(8, 12));

            personId = newPid;
        } catch (FormatException) {
            return personId;
        }
    }

    return personId;
}

function isValidPersonIdDate(year: string, month: string, day: string): boolean {
    return isValidDate(year, month, day) || isValidSamordningsnummerDate(year, month, day);
}

function isValidDate(year: string, month: string, day: string): boolean {
    let isValid: boolean;
    try {
        if (parseInt(year) > 1800) {
            // person can't have a birth year earlier than 1800
            const dateString = year + "-" + month + "-" + day;
            isValid = dateHelper.isValidDateFormat(dateString);
        } else {
            isValid = false;
        }
    } catch (e) {
        isValid = false;
    }

    return isValid;
}

function isValidSamordningsnummerDate(year: string, month: string, day: string): boolean {
    const dayNum = parseInt(day);

    if (isNaN(dayNum)) {
        return false;
    }

    const newDay = (dayNum - 60).toLocaleString(undefined, { minimumIntegerDigits: 2 });

    return isValidDate(year, month, newDay);
}

function verifyCheckDigit(pid: string): boolean {
    let result = 0;
    let mult = 2;

    for (let i = 11; i > 2; i--) {
        const sum = parseInt(pid[i - 1].toString()) * mult;
        result += Math.floor(sum / 10);
        result += sum % 10;
        mult = mult === 2 ? 1 : 2;
    }

    if (result > 9) {
        result = result % 10;
    }

    result = result === 0 ? result : 10 - result;
    return parseInt(pid[11].toString()) === result;
}

export default {
    validatePersonId: validatePersonId,
    validatePersonIdAllowZeros: validatePersonIdAllowZeros,
    stripTransform: stripTransform,
    doTransform: doTransform
};
